export const FUND_STATUS_DICT = {
  operacional: 'operational',
  cancelado: 'canceled',
  'pre-operacional': 'pre-operational',
  'EM FUNCIONAMENTO NORMAL': 'operational',
  CANCELADA: 'canceled',
  'FASE PRÉ-OPERACIONAL': 'pre-operational',
};

export const FUND_STATUS_LABEL = {
  operacional: 'Operacional',
  cancelado: 'Cancelado',
  'pre-operacional': 'Pré-operacional',
  'EM FUNCIONAMENTO NORMAL': 'Operacional',
  CANCELADA: 'Cancelado',
  'FASE PRÉ-OPERACIONAL': 'Pré-operacional',
};
